import {
  getPaymentMethodsSource,
  listProductConfigs,
} from '@/app/config/products.config';
import { useMemo } from 'react';
import {
  buildPaymentSettingsRows,
  type ProductDescriptors,
} from '../utils/payment-settings-list.util';
import { CATALOG_SOURCE_LABELS } from '../utils/payment-settings-labels.util';
import { useProductPaymentSettingsList } from './use-product-payment-settings-list.hook';

/** Lista de produtos da tela de formas de pagamento, pronta para renderizar. */
export function usePaymentSettingsListViewModel() {
  const { data, isLoading, error, refetch } = useProductPaymentSettingsList();

  const products = useMemo<ProductDescriptors>(
    () =>
      Object.fromEntries(
        listProductConfigs().map(config => [
          config.productCode,
          {
            name: config.displayName,
            paymentMethodsSource: getPaymentMethodsSource(config.productCode),
          },
        ])
      ),
    []
  );

  const rows = useMemo(
    () => (data ? buildPaymentSettingsRows(data, products) : []),
    [data, products]
  );

  return {
    rows,
    isLoading,
    error:
      error instanceof Error
        ? error.message
        : error
          ? 'Não foi possível carregar a lista.'
          : null,
    refetch,
    catalogSourceLabel: data
      ? CATALOG_SOURCE_LABELS[data.catalogSource]
      : undefined,
    catalogEditable: data?.catalogEditable ?? false,
  };
}
